import { getGeoValueByType } from '@/packages/JsonQuery';
import { type IJsonQueryHighway } from '@/packages/api-models/common/json_query';

import { type TModifier } from '../../../../../types/modifier';
import { nonEmptyArrayOr } from '../../../../../utils/nonEmptyArrayOr';
import { type ITagGroupConfig, type TagGeoHighwayDirectionSchema } from '../types';

export const geoHighwayDirection: ITagGroupConfig = {
  get({ jsonQuery, highways: directions }) {
    const jqValues = getGeoValueByType<IJsonQueryHighway>('highway')(jsonQuery);
    if (!jqValues) {
      return null;
    }

    const jqValuesIds = jqValues.map(({ id }) => id);

    const tagsGroup = directions.reduce<TagGeoHighwayDirectionSchema[]>((acc, direction) => {
      // Если выбраны все шоссе из направления
      if (direction.highways.every(highway => jqValuesIds.includes(highway.id))) {
        // Добавляется псевдотег "направление"
        acc.push({
          group: 'geoHighwayDirection',
          text: `${direction.name} направление`,
          data: direction.highways.map(({ id }) => id),
        });
      }

      return acc;
    }, []);

    return nonEmptyArrayOr(tagsGroup);
  },
  delete({ onChange }, tag: TagGeoHighwayDirectionSchema) {
    // Чтобы удалить псевдотег "направление", нужно удалить все шоссе, которые к этому направлению привязаны
    const removeHighwaysModifiers = nonEmptyArrayOr<TModifier>(
      tag.data.map(id => ({
        action: 'removeGeo',
        arguments: [{ type: 'highway', id }],
      })),
    );

    if (!removeHighwaysModifiers) {
      return;
    }

    onChange(...removeHighwaysModifiers);
  },
};
